import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import Triangle from "assets/svg/triangleDown.svg";

const Wrapper = styled.div`
  overflow-x: auto;
  border-left: 1px solid ${({ theme }) => theme.palette.blue.lighter};
`;

const Table = styled.table`
  border-collapse: collapse;
  @media print {
     font-size:12px;
     width:100%;
  }
  th {
    color: ${({ theme }) => theme.palette.white};
    background-color: ${({ theme }) => theme.palette.blue.medium};
    border: 1px solid ${({ theme }) => theme.palette.blue.light};

    button {
        @media print {
          font-size:12px;
        }
      background-color: transparent;
      border: none;
      color: inherit;
      padding: ${({ theme }) => theme.spacer}px;
      @media print {
       padding:10px 5px;
      }
      font-size: inherit;
      width: 100%;
      text-align: left;
      position: relative;
      display: flex;
      align-items: center;
      &:focus {
        box-shadow: none;
      }

      ${({ theme }) => theme.mediaQueries.medium} {
        padding-right: ${({ theme }) => theme.spacer * 2.6}px;
        &::before,
        &::after {
          position: absolute;
          right: 8px;

          content: "";
          width: 12px;
          height: 12px;
          transform-origin: 50%;
          background-image: url(${Triangle});
          background-size: contain;
          background-repeat: no-repeat;

          opacity: 0.3;
        }

        &:before {
          transform: translateY(7px);
        }
        &:after {
          transform: translateY(-8px) rotate(180deg);
        }

        &.ascending {
          &:after {
            opacity: 0.8;
          }
        }
        &.descending {
          &:before {
            opacity: 0.8;
          }
        }
      }
    }
  }

  td {
    padding: ${({ theme }) => theme.spacer}px;
    text-align: center;
    border: 1px solid ${({ theme }) => theme.palette.blue.lighter};
    svg {
      width: 0.8rem;
      margin: 0 1px;
      @media print {
       width:8px;
      }
    }
  }

  th:first-child {
    background-color: ${({ theme }) => theme.palette.blue.darker};
    
  }

  th:first-child,
  td:first-child {
    position: sticky;
    z-index: 2;
    left: 0px;
    text-align: left;
    border-left: none;
    min-width: unset;
    @media print {
      min-width:170px;
    }

    ${({ theme }) => theme.mediaQueries.large} {
      min-width: 250px;
    }
  }

  tbody {
    tr {
      td {
        background-color: ${({ theme }) => theme.palette.background.azure};
      }
    }

    tr:nth-child(even) {
      td {
        background-color: ${({ theme }) => theme.palette.white};
      }
    }
  }
`;

const TableComponent = ({ className, children }) => {
  const classes = ["Table"];
  if (className) classes.push(className);

  return (
    <Wrapper className={classes.join(" ")}>
      <Table>{children}</Table>
    </Wrapper>
  );
};

TableComponent.displayName = "Table";

TableComponent.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node.isRequired,
};

TableComponent.defaultProps = {
  className: null,
};

export default TableComponent;
